module.exports = __webpack_public_path__ + "static/media/XXIVe.12bbf021.png";